import ApiService from '@common/lib/api/api.service';
import { stringify } from 'query-string';

export const getMainProducts = () => {
  return ApiService.query('product/mainProducts');
};

export const getInternetBestProducts = params => {
  return ApiService.query(`product/internetBestProducts?${stringify(params)}`);
};
